"use client";
import * as React from "react";
const SvgLogoutSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M12 3.11 10.88 4.2l2.08 2.02H4.8v1.56h8.16L10.88 9.8 12 10.89 16 7zM1.6 1.56H8V0H0v14h8v-1.56H1.6z" }));
export {
  SvgLogoutSharp as default
};
